<template>
  <div class="pinyin">
    <!-- <i-title titleText="汉字转拼音"></i-title> -->
    <div class="wrapper">
      <textarea class="default-text" v-model="leftVal" placeholder="输入要转换的汉字"></textarea>
      <textarea class="minify-text" id="pinyinCode" placeholder="转换结果" v-model="rightVal"></textarea>
    </div>
    <div class="btn-wrap">
      <button class="btn btn-default" @click="changeNumber">
        汉字转拼音
      </button>
      <button
        class="btn btn-copy"
        id="cppyBtn"
        @click="handleCopy"
        data-clipboard-target="#pinyinCode"
      >
        {{ copyText }}
      </button>
    </div>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro'
import ClipboardJS from 'clipboard'

export default {
  name: 'Huoxingwen',
  data () {
    return {
      leftVal: '',
      rightVal: '',
      copyText: '复制'
    }
  },
  methods: {
    changeNumber () {
      this.rightVal = pinyin(this.leftVal, { multiple: true })
    },
    handleCopy () {
      if (this.rightVal) {
        var clipboard = new ClipboardJS('#cppyBtn');
        const that = this
        clipboard.on('success', function(e){
          e.clearSelection();
          that.copyText = '已复制'
        })
      }
    }
  }
}
</script>

<style scoped>
.sql {
  width: 1200px;
  margin: 0 auto;
}
.wrapper {
  width: 1200px;
  height: 300px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.wrapper textarea {
  box-sizing: border-box;
  width: 590px;
  border: 1px solid #eee;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  line-height: 1.3em;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  height: 100%;
  margin-bottom: 9px;
  color: #555555;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border-collapse: collapse;
  transition: border linear 0.2s, box-shadow linear 0.2s;
  resize: none;
  padding: 5px 15px;
}
.wrapper textarea:focus {
  border-color: #1890ff;
  outline: 0;
}
.btn-wrap {
  display: flex;
}
.btn {
  height: 42px;
  font-size: 14px;
  border: 0;
  cursor: pointer;
  border-radius: 4px;
  margin-right: 10px;
  margin-top: 22px;
  padding: 0 15px;
  min-width: 100px;
  box-sizing: border-box;
  color: #fff;
}
.btn:hover {
  opacity: 0.8;
}
.btn.btn-default{
  background: #409eff;
}
.btn.btn-copy{
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}
.btn.btn-copy:hover{
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
</style>
